import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import Mantain from "../../../assets/images/DietPlans/Mantain.png";
import Hormonal from "../../../assets/images/DietPlans/Hormonal.png";
import metabolism from "../../../assets/images/DietPlans/metabolism.png";
import Gain from "../../../assets/images/DietPlans/Gain.png";
import DND from "../../../assets/images/DietPlans/DND.png";

import Weightloss from "../../../assets/images/DietPlans/Weightloss.png";
import PreDiabetes from "../../../assets/images/DietPlans/PreDiabetes.png";
import Hypertension from "../../../assets/images/DietPlans/Hypertension.png";
import MuscleGain from "../../../assets/images/DietPlans/MuscleGain.png";
import Thyroid from "../../../assets/images/DietPlans/Thyroid.png";
import PCOD from "../../../assets/images/DietPlans/PCOD.png";
import Diabetes from "../../../assets/images/DietPlans/Diabetes.png";

const stepArray = [
  {
    title: "Weight loss",
    subTitle: [
      {
        image: metabolism,
        title: "Improve metabolism",
      },
      {
        image: Hormonal,
        title: "Hormonal balance",
      },
      {
        image: Mantain,
        title: "Mantain healthy BMI",
      },
    ],
    image: Weightloss,
    width: "90px",
    categoryId: "weight_loss",
  },
  {
    title: "Muscle Gain",
    subTitle: [
      {
        image: Gain,
        title: "Sustainable gain in muscles",
      },
      {
        image: Mantain,
        title: "Increase strength and stamina",
      },
      {
        image: metabolism,
        title: "Boost metabolism",
      },
    ],
    image: MuscleGain,
    width: "110px",
    categoryId: "muscle_gain",
  },
  {
    title: "Thyroid",
    subTitle: [
      {
        image: DND,
        title: "Reduce hair fall",
      },
      {
        image: Hormonal,
        title: "Hormonal balance",
      },
      {
        image: Mantain,
        title: "Manage hypo & hyperthyroidism",
      },
    ],
    image: Thyroid,
    width: "110px",
    categoryId: "thyroid",
  },
  {
    title: "PCOD",
    subTitle: [
      {
        image: metabolism,
        title: "Improve metabolism",
      },
      {
        image: Hormonal,
        title: "Hormonal balance",
      },
      {
        image: Mantain,
        title: "Mantain healthy BMI",
      },
    ],
    image: PCOD,
    width: "110px",
    categoryId: "pcod",
  },
  {
    title: "Diabetes",
    subTitle: [
      {
        image: metabolism,
        title: "Reduce insulin resistance",
      },
      {
        image: Hormonal,
        title: "Manage glucose levels",
      },
      {
        image: Mantain,
        title: "Prevent or Slow complications",
      },
    ],
    image: Diabetes,
    width: "90px",
    categoryId: "diabetes",
  },
  {
    title: "Hypertension",
    subTitle: [
      {
        image: metabolism,
        title: "Prevention of stroke",
      },
      {
        image: Hormonal,
        title: "Maintain sodium level",
      },
      {
        image: Mantain,
        title: "Lower body inflammation",
      },
    ],
    image: Hypertension,
    width: "90px",
    categoryId: "hypertension",
  },
  {
    title: "Pre- Diabetes",
    subTitle: [
      {
        image: metabolism,
        title: "Reverse pre-diabetes",
      },
      {
        image: Hormonal,
        title: "Boost metabolism",
      },
      {
        image: Mantain,
        title: "Manage healthy body weight",
      },
    ],
    image: PreDiabetes,
    width: "90px",
    categoryId: "pre_diabetes",
  },
];

const PlanCategory = ({ categoryId, setCategoryId, disabled }) => {
  const handleClick = (value) => {
    if (disabled) return;
    setCategoryId(value);
  };

  return (
    <div className="goal-popup-list">
      {stepArray.map((step) => {
        const isSelected = categoryId === step.categoryId;
        return (
          <button
            type="button"
            key={step.categoryId}
            className="goal-popup-row"
            onClick={() => handleClick(step.categoryId)}
            disabled={disabled}
          >
            <div className="goal-popup-left">
              <div className="goal-popup-img-wrap">
                <img
                  src={step.image}
                  alt={step.title}
                  loading="lazy"
                />
              </div>
              <span className="goal-popup-title">{step.title}</span>
            </div>
            <div
              className={`goal-popup-radio ${
                isSelected ? "checked" : ""
              }`}
            />
          </button>
        );
      })}
    </div>
  );
};

export default PlanCategory;
